import { Component, OnInit } from '@angular/core';
import { MedicalServiceWizardService } from '../../../services/wizard/medical-service/medical-service-wizard';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { WizardStep } from '../../../wizard/wizard.component';
import { FormBuilder } from '@angular/forms';
import { FilterService } from '../../../services/filter.service';
import { MedicalAppointmentProcedure } from '../../../model/medical-appointment-procedure';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-medical-service-consultation-history-component',
  templateUrl: './medical-service-consultation-history.component.html',
  styleUrls: ['./medical-service-consultation-history.component.css']
})
export class MedicalServiceConsultationHistoryComponent implements OnInit, WizardStep {

  completed: boolean;
  isInit: boolean;
  medicalAppointmentId: number;
  patientId: number;

  constructor(private medicalServiceWizardService: MedicalServiceWizardService) {
      this.medicalAppointmentId = medicalServiceWizardService.medicalServiceSearchItem.MedicalAppointmentId;
      this.patientId = medicalServiceWizardService.medicalServiceSearchItem.PatientId;
  }

  ngOnInit(): void {

  }

  loaded() {
    this.completed = true;
  }

  medicalConsultationMedicationChange(value: string) {
    this.medicalServiceWizardService.setMedicalConsultationMedication(value);
  }

  medicalConsultationObservationChange(value: string) {
    this.medicalServiceWizardService.setMedicalConsultationObservation(value);
  }

  get valid(): boolean {
    return this.completed;
  }


  activate(): void {
  }

  save(): void {

  }
}
